import React from 'react'
import Svg from '../../Svg'
import { Link } from 'react-router-dom'

export default function Logo() {
    return (
        <div className="left-menu d-flex align-items-center">
            <Link to="/admin/survey/list" className='home-icon'>
                <Svg name="logo" />
            </Link>
        </div>
    )
}
